import { NavLink as NL } from '@/types'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { NavLink } from 'react-router-dom'

const NavItem: React.FC<NL> = ({
  to,
  icon,
  label,
  afterTextSize = 'after:text-xl',
  bottomOffset = 'after:bottom-6',
}) => {
  return (
    <NavLink
      className={({ isActive }) =>
        `block
        text-4xl
        text-gray-500
        leading-[51px]
        w-full
        h-[51px]
        relative
        hover:text-primary
        hover:bg-black
        transition-all
        ease-out
        duration-300
        after:content-[attr(data-content)]
        ${afterTextSize}
        after:tracking-wider
        after:absolute
        after:-left-0
        ${bottomOffset}
        after:w-full
        after:transition-all
        after:ease-out
        after:duration-300
        after:opacity-0
        after:hover:opacity-100
        ${
          isActive
            ? 'text-primary'
            : 'text-gray-500 hover:text-primary hover:bg-black hover:after:opacity-100'
        }`
      }
      to={to}
      data-content={label}
    >
      <FontAwesomeIcon icon={icon} />
      <span className="sr-only">{label}</span>
    </NavLink>
  )
}

export default NavItem
